import {Component, effect, ElementRef, inject, input, signal, viewChild} from "@angular/core";
import {DeviceViewService, LayoutVariants} from "@services";

@Component({
	selector: "sim-marquee-text",
	templateUrl: "./marquee-text.component.html",
	styleUrl: "./marquee-text.component.scss",
})
export class MarqueeTextComponent {
	// I/O
	public readonly text = input<string | null>("");
	public readonly containerWidth = input<number>(0);

	// Properties
	protected readonly shouldScroll = signal<boolean>(false);
	#resizeObserver?: ResizeObserver;

	// Constants
	protected readonly LayoutVariants = LayoutVariants;

	// Children
	protected readonly primaryEl = viewChild<ElementRef<HTMLSpanElement>>("primaryEl");

	// Injections
	protected readonly deviceViewService = inject(DeviceViewService);

	// Effects
	readonly #resizeEffect = effect((onCleanup) => {
		const el = this.primaryEl()?.nativeElement;
		if (!el) return;

		this.#resizeObserver?.disconnect();
		this.#resizeObserver = new ResizeObserver(() => {
			const scrollDistance = el.scrollWidth - el.offsetWidth;
			el.style.setProperty("--marquee-scroll-distance", `-${scrollDistance}px`);

			this.shouldScroll.set(scrollDistance > 0);
		});
		this.#resizeObserver.observe(el);

		const scrollDistance = el.scrollWidth - el.offsetWidth;
		el.style.setProperty("--marquee-scroll-distance", `-${scrollDistance}px`);
		this.shouldScroll.set(scrollDistance > 0);

		onCleanup(() => {
			this.#resizeObserver?.disconnect();
			this.#resizeEffect.destroy();
		});
	});
}
